import React from 'react';
import Icon from '../../../components/AppIcon';

const MobileAppSection = () => {
  const features = [
    {
      icon: 'Smartphone',
      text: 'Full budgeting power on the go'
    },
    {
      icon: 'Zap',
      text: 'Optimized for phones and tablets'
    },
    {
      icon: 'Bell',
      text: 'Push notifications for payments'
    },
    {
      icon: 'Wifi',
      text: 'Sync seamlessly across devices'
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-br from-primary/10 via-accent/5 to-primary/10">
      <div className="mx-auto px-4 md:px-6 lg:px-24 max-w-5xl">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-primary/20 rounded-full mb-4 md:mb-6">
            <Icon name="Smartphone" size={32} color="var(--color-primary)" strokeWidth={2} />
          </div>
          
          <div className="inline-flex items-center px-4 py-2 bg-accent/20 rounded-full mb-4 md:mb-6">
            <Icon name="Sparkles" size={16} color="var(--color-accent)" className="mr-2" />
            <span className="text-sm font-caption font-semibold text-accent">Coming Soon</span>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-secondary mb-3 md:mb-4">
            Mobile App Launching Soon
          </h2>

          <p className="text-base md:text-lg text-muted-foreground mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed">
            Take Rovyn Budget with you wherever you go. Our mobile app brings the full power of financial management to your pocket.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 max-w-2xl mx-auto mb-8 md:mb-10">
            {features?.map((feature, index) => (
              <div
                key={index}
                className="flex items-center gap-3 bg-card rounded-xl p-4 md:p-5 shadow-elevation-2"
              >
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name={feature?.icon} size={20} color="var(--color-primary)" strokeWidth={2} />
                </div>
                <span className="text-sm md:text-base text-card-foreground font-medium text-left">
                  {feature?.text}
                </span>
              </div>
            ))}
          </div>

          <p className="text-base md:text-lg text-primary font-semibold">
            Join now and be the first to know when we launch!
          </p>
        </div>
      </div>
    </section>
  );
};

export default MobileAppSection;